/// requestAnimationFrame driver for the game session.
///
/// Clamps dt to [0, 0.05]s so a backgrounded tab doesn't trigger a
/// huge jump on resume. Returns a stop function.

import type { GameSession } from './GameSession'

const MAX_DT = 0.05

export function startTickLoop(session: GameSession): () => void {
  let raf = 0
  let last = performance.now()
  let stopped = false

  const frame = (now: number) => {
    if (stopped) return
    const dt = Math.max(0, Math.min(MAX_DT, (now - last) / 1000))
    last = now
    session.tick(dt)
    raf = requestAnimationFrame(frame)
  }
  raf = requestAnimationFrame(frame)

  return () => {
    stopped = true
    if (raf) cancelAnimationFrame(raf)
  }
}
